import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { getArtifactsColumns } from "./AllArtifacts.columns";
import { artifactsRows } from "./AllArtifacts.data";

interface AllArtifactsTableProps {
  onActionClick: (_number: number) => void;
}

const AllArtifactsTable = ({ onActionClick }: AllArtifactsTableProps) => {
  const columns = getArtifactsColumns(onActionClick);

  return (
    <DefaultDataGrid
      loading={false}
      rows={artifactsRows}
      columns={columns}
      getRowHeight={() => "auto"}
      disableRowSelectionOnClick
      pageSizeOptions={[5, 10, 20]}
      disableCellFocus
      initialState={{
        pagination: { paginationModel: { pageSize: 20 } },
      }}
      sx={{
        "& .MuiDataGrid-cell": {
          alignItems: "center",
          py: 1,
        },
      }}
    />
  );
};

export default AllArtifactsTable;
